import AddInspection from "./AddInspection";
import EditInspection from "./EditInspection";
import Inspections from "./Inspection";

export default Inspections;
export { AddInspection, EditInspection };
